<template>
	<div class="min-vh-100 pb-5">
		<div>{{vehicle.marque}} {{vehicle.modele}}</div>
        <br>


		<b-form-group class="my-2" v-if="display=='possible'">
			<b-form-checkbox size="lg" v-model="form.typelavage" switch   name="typelavage[]" :value="type"
			v-for="type in lavagetypes" :key="`checkbox-`+type"
							 class="custom-control-lg">
				{{type}}
			</b-form-checkbox>
			<div v-if="errors.typelavage" class="invalid-feedback">{{$t('selectAtLeastOne')}}</div>
		</b-form-group>


		<b-form-group  class="my-2" v-if="display=='possible'">
      <slot name="label">{{$t('key')}} <span style="color: red">*</span></slot>
			<b-form-select v-model="form.cle" :class="{'is-invalid':errors.cle}">
				<option value=""></option>
				<option value="CH">{{$t('keyOptions.CH')}}</option>
				<option value="R">{{$t('keyOptions.R')}}</option>
				<option value="C">{{$t('keyOptions.C')}}</option>
				<option value="CA">{{$t('keyOptions.CA')}}</option>
				<option value="PC">{{$t('keyOptions.PC')}}</option>
			</b-form-select>
			<div v-if="errors.cle" class="invalid-feedback">{{$t('Please choise a awnser')}}</div>
		</b-form-group>

		<b-form-group  class="my-2" v-if="display=='impossible'">
      <slot name="label">{{$t('impossibleWashJustification')}} <span style="color: red">*</span></slot>
			<b-form-select v-model="form.motif" :class="{'is-invalid':errors.motif}">
				<option value=""></option>
				<option value="Véhicule absent">{{$t('justificationOptions.VehiculeAbsent')}}</option>
				<option value="Pas de clé">{{$t('justificationOptions.PasDeCle')}}</option>
				<option value="Chargé">{{$t('justificationOptions.Charge')}}</option>
				<option value="Non inscrit dans le listing">{{$t('justificationOptions.Non inscrit dans le listing')}}</option>
				<!-- <option value="Lavage du parc sur plusieurs interventions">{{$t('justificationOptions.MultiJour')}}</option> -->
				<option value="Autre">{{$t('justificationOptions.Autre')}}</option>
			</b-form-select>
			<div v-if="errors.motif" class="invalid-feedback">{{$t('specifyPlaceholder')}}</div>
		</b-form-group>

    <b-form-group class="my-2" v-if="display=='impossible' && form.motif =='Autre'">
      <slot name="label">{{$t('specifyLabel')}} <span style="color: red">*</span></slot>

      <b-form-textarea
          v-model="form.motif_autre"
          placeholder="Préciser le motif"
          :class="{'is-invalid':errors.motif_autre}">
      </b-form-textarea>

      <div v-if="errors.motif_autre" class="invalid-feedback">{{$t('Please choise a awnser')}}</div>


    </b-form-group>

		<pictures :uid="eventid" name="lavage"
					:vehicleid="vehicleid" class="my-2">{{$t('Pictures')}}</pictures>


		<a href="#" v-if="display=='possible'" @click.prevent="lavageimpossible" class="btn btn-block btn-warning mt-5">{{$t('impossibleWashButton')}}</a>
		<a href="#" v-if="display=='impossible'" @click.prevent="lavagepossible" class="btn btn-block btn-success mt-5">{{$t('possibleWashButton')}}</a>
		<a href="#" @click.prevent="save" class="btn btn-block btn-primary">{{$t('validateButton')}}</a>

		<a href="#" @click.prevent="cancel" class="btn btn-block btn-outline-danger mt-4">{{$t('cancelButton')}}</a>
	</div>
</template>


<script>
	
	// @ is an alias to /src
	import {mapActions, mapGetters} from 'vuex'
	import Pictures from '@/components/Pictures.vue';
	
	export default {
		name: 'vehicle',
		props: ['eventid', 'vehicleid'],
		components:{Pictures},
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvent'
			]),
			...mapGetters('config', {'config': 'getConfig'}),
			...mapGetters('interventions', [
				'getIntervention'
			]),
			vehicle(){
				return _.find(this.event.parcs, {id: this.vehicleid})
			}
		},
		created: function () {
			this.event = this.getEvent(this.eventid);
			this.intervention = this.getIntervention(this.eventid);
			this.setPageTitle(this.vehicle.name);
			this.populateLavageTypes();
		},

		mounted(){
			this.form = this.intervention.parcs[this.vehicleid];
			if (this.form.motif){
				this.display = 'impossible';
			}
		},

		data: function () {
			return {
				event: {},
				intervention: {},
				lavagetypes: [],
				display: 'possible',
				form: {
					motif: '', // justificatif de non lavage
					motif_autre: '', // justificatif de non lavage dans le cas de autre
					cle: '',
					typelavage: [],
					start_at: '',
					end_at: ''
				},
				errors: {
					motif: false, // justificatif de non lavage
          			motif_autre: false,
					cle: false,
					typelavage: false,
				}
			}
		},
        methods: {
			...mapActions('config', ['setPageTitle']),
			...mapActions('interventions', ['saveVehicle', 'removeVehicle']),
			populateLavageTypes(){
				let exludedLavageForTypes = {
					'Utilitaire': ['Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Tracteur': ['Désinfection intérieure caisse', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Semi remorque': ['Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Benne': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Porteur': ['Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Remorque': ['Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Plateau': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Pompe à carburant': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Pelle': ['Désinfection intérieure caisse', 'Rénovation sol (avec brosse hp)', 'Station carburant'],
					'Manitou': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Chariot Elevateur': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Filtre hydrocarbure': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Voiture': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Benne Ampliroll': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Benne Multi': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Porteur Ampliroll Grue': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Porteur Ampliroll': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Porteur Multi': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Palette de rétention': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Porteur Skipper': ['Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Benne Skipper': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min'],
					'Semi porte voiture': ['Désinfection intérieure caisse', 'Rénovation Alu (jantes, barre anti-encastrement, réservoir, hayon)', 'Rénovation sol (avec brosse hp)', 'Station carburant', 'Nettoyage moteur < 30min', 'Nettoyage moteur > 30min']
				}

				// exclure les prestations qui ne sont pas possible pour ce type de véhicule
				this.lavagetypes = _.difference(this.event.prestations, exludedLavageForTypes[this.vehicle.type]);
				if (this.lavagetypes.length == 0) {
					alert(this.$t('noWashPossible'));
				}
			},
			lavageimpossible(){
				this.form.motif = '';
				this.form.motif_autre = '';
				this.form.cle = '';
				this.form.typelavage = [];
				this.display = 'impossible';
			},
			lavagepossible(){
				this.form.motif = '';
				this.form.motif_autre = '';
				this.display = 'possible';
			},
			cancel(){
				if (confirm(this.$t('cancelVehicleText'))) {
					this.removeVehicle({uid: this.eventid, vehicleid: this.vehicleid});
					this.$router.push({name: 'vehicles', params:{eventid: this.eventid}});
				}
			},
			save(){
				if (this.display == 'possible') {
					if (this.form.typelavage.length == 0) {
						this.errors.typelavage = true;
						return;
					}
					if (!this.form.cle) {
						this.errors.cle = true;
						return;
					}
				} else {
					if (!this.form.motif) {
						this.errors.motif = true;
						return;
					}
					if (this.form.motif == 'Autre' && this.form.motif_autre.length == 0 ){
						this.errors.motif_autre = true;
						return;
					}
				}
				this.saveVehicle({uid: this.eventid, vehicleid: this.vehicleid, data: this.form});
			    this.$router.push({name: 'vehicles', params:{eventid: this.eventid}});
			}
        }
	}
</script>
